import { useState } from 'react';

interface UnderConstructionProps {
  pageName: string;
}

export default function UnderConstruction({ pageName }: UnderConstructionProps) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Email submitted:', email);
    setSubmitted(true);
  };

  return (
    <div 
      className="min-h-screen"
      style={{
        backgroundImage: 'url(/images/under-construction-bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-tactical-black/90 backdrop-blur border-b border-tactical-border">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src="/images/COUP_logo.png" alt="CounterScript" className="h-8 w-auto" />
            <span className="font-headline text-xl tracking-wider text-white">COUNTERSCRIPT HQ</span>
          </a>
          <div className="flex items-center gap-8">
            <a href="/" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">HOME</a>
            <a href="/training" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">TRAINING</a>
            <a href="https://play.counterscripthq.com/data-hub" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">DATA HUB</a>
            <a href="/gear" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">GEAR</a>
            <a href="/contact" className="font-headline text-sm tracking-widest text-white hover:text-tactical-amber transition">CONTACT</a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex items-center justify-center px-4 pt-32 pb-20 min-h-screen">
        <div className="absolute inset-0 bg-black/70"></div>
        
        <div className="relative z-10 max-w-2xl w-full">
          <div className="tactical-card tactical-card-glow text-center">
            
            {/* Warning Icon */}
            <div className="text-tactical-amber text-6xl mb-6">⚠</div>
            
            {/* Title */}
            <h1 className="font-headline text-4xl md:text-5xl tracking-wider text-white mb-4">
              {pageName.toUpperCase()}
            </h1>
            
            {/* Subtitle */}
            <p className="font-headline text-xl tracking-widest text-tactical-amber mb-6">
              — SECTOR UNDER CONSTRUCTION —
            </p>
            
            {/* Message */}
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              This wing of HQ is currently being built. Our engineers are working around the clock to get this sector operational. Sign up below to receive an alert when construction is complete.
            </p>
            
            {/* Email Signup */}
            {!submitted ? (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                    className="flex-1 bg-tactical-black border border-tactical-border text-white px-4 py-3 font-body focus:outline-none focus:border-tactical-amber transition"
                  />
                  <button
                    type="submit"
                    className="font-headline tracking-widest border-2 border-tactical-amber text-tactical-amber px-8 py-3 hover:bg-tactical-amber hover:text-black transition"
                  >
                    NOTIFY ME
                  </button>
                </div>
              </form>
            ) : (
              <div className="tactical-card tactical-card-cyan p-4">
                <p className="text-tactical-cyan font-headline tracking-wider">
                  ✓ TRANSMISSION RECEIVED
                </p>
                <p className="text-gray-400 mt-2">
                  You'll be notified when this sector goes live.
                </p>
              </div>
            )}
            
            {/* Back Link */}
            <a 
              href="/"
              className="inline-block mt-8 font-headline text-sm tracking-widest text-gray-500 hover:text-white transition"
            >
              ← RETURN TO HQ
            </a>
            
          </div>
        </div>
      </div>
    </div>
  );
}
